import {
  CHANGE_LANGUAGE,
  RESET_STATE,
  SET_COORDS,
  SET_GEOLOCATION,
  SET_PERSISTENCE,
  SET_THEME_MODE
} from "./actionTypes";

const handlePersistence = (stateToStringify) => {
  localStorage.setItem('state', JSON.stringify(stateToStringify));
}

const AppReducer = (state, action) => {
  switch (action.type) {
    case SET_PERSISTENCE:
      return action.payload
    case RESET_STATE:
      handlePersistence(action.payload)
      return action.payload
    case CHANGE_LANGUAGE:
      const languagePayload = {
        ...state,
        language: action.payload
      }
      handlePersistence(languagePayload)
      return languagePayload
    case SET_THEME_MODE:
      const themeModePayload = {
        ...state,
        themeMode: action.payload
      }
      handlePersistence(themeModePayload)
    case SET_GEOLOCATION:
      const geolocationPayload = {
        ...state,
        geolocation: action.payload
      }
      handlePersistence(geolocationPayload)
      return geolocationPayload
    case SET_COORDS:
      const coordsPayload = {
        ...state,
        coords: action.payload
      }
      handlePersistence(coordsPayload)
      return coordsPayload
    default:
      return state;
  }
};

export default AppReducer;
